import type {
  TeamMembershipControllerAddTeamMembershipData,
  TeamMembershipControllerAddTeamMembershipResponse,
  TeamMembershipControllerDeleteData,
  TeamMembershipControllerDeleteResponse,
  TeamMembershipControllerGetTeamMembershipByIdsData,
  TeamMembershipControllerGetTeamMembershipByIdsResponse,
  TeamMembershipControllerGetTeamMembershipData,
  TeamMembershipControllerGetTeamMembershipResponse,
  TeamMembershipControllerImportTeamMembershipData,
  TeamMembershipControllerImportTeamMembershipResponse,
  TeamMembershipControllerUpdateTeamMembershipData,
  TeamMembershipControllerUpdateTeamMembershipResponse,
} from '~/api';
import {
  teamMembershipControllerAddTeamMembership,
  teamMembershipControllerDelete,
  teamMembershipControllerGetTeamMembership,
  teamMembershipControllerGetTeamMembershipByIds,
  teamMembershipControllerImportTeamMembership,
  teamMembershipControllerUpdateTeamMembership,
} from '~/api';
import { heyApiQuery } from '~/utils/api';

import api from '..';

export const teamMemberships = api.injectEndpoints({
  endpoints: builder => ({
    getTeamMembership: builder.query<
      TeamMembershipControllerGetTeamMembershipResponse,
      TeamMembershipControllerGetTeamMembershipData['query']
    >({
      queryFn: query => heyApiQuery(() => teamMembershipControllerGetTeamMembership({ query })),
      providesTags: result =>
        result?.success
          ? [
              ...result.data.map(({ id }: { id: number }) => ({ type: 'TEAM_MEMBERSHIPS', id }) as const),
              { type: 'TEAM_MEMBERSHIPS', id: 'ALL' },
            ]
          : [{ type: 'TEAM_MEMBERSHIPS', id: 'ALL' }],
    }),

    importTeamMembership: builder.mutation<
      TeamMembershipControllerImportTeamMembershipResponse,
      TeamMembershipControllerImportTeamMembershipData['body']
    >({
      queryFn: params => heyApiQuery(() => teamMembershipControllerImportTeamMembership({ body: params })),
      invalidatesTags: (_result, error) => {
        return error ? [] : [{ type: 'TEAM_MEMBERSHIPS', id: 'ALL' }];
      },
    }),

    getTeamMembershipByIds: builder.query<
      TeamMembershipControllerGetTeamMembershipByIdsResponse,
      TeamMembershipControllerGetTeamMembershipByIdsData['query']
    >({
      queryFn: query => heyApiQuery(() => teamMembershipControllerGetTeamMembershipByIds({ query })),
      providesTags: result =>
        result?.success
          ? [
              ...result.data.map(({ id }: { id: number }) => ({ type: 'TEAM_MEMBERSHIPS', id }) as const),
              { type: 'TEAM_MEMBERSHIPS', id: 'ALL' },
            ]
          : [{ type: 'TEAM_MEMBERSHIPS', id: 'ALL' }],
    }),

    deleteTeamMembership: builder.mutation<
      TeamMembershipControllerDeleteResponse,
      TeamMembershipControllerDeleteData['path']['id']
    >({
      queryFn: id => heyApiQuery(() => teamMembershipControllerDelete({ path: { id } })),
      invalidatesTags: () => [{ type: 'TEAM_MEMBERSHIPS', id: 'ALL' }],
    }),
    addTeamMembership: builder.mutation<
      TeamMembershipControllerAddTeamMembershipResponse,
      TeamMembershipControllerAddTeamMembershipData['body']
    >({
      queryFn: body => heyApiQuery(() => teamMembershipControllerAddTeamMembership({ body })),
      invalidatesTags: (_result, error) => {
        return error ? [] : [{ type: 'TEAM_MEMBERSHIPS', id: 'ALL' }];
      },
    }),
    updateTeamMembership: builder.mutation<
      TeamMembershipControllerUpdateTeamMembershipResponse,
      { id: number; payload: TeamMembershipControllerUpdateTeamMembershipData['body'] }
    >({
      queryFn: ({ id, payload }) =>
        heyApiQuery(() => teamMembershipControllerUpdateTeamMembership({ path: { id }, body: payload })),
      invalidatesTags: () => [{ type: 'TEAM_MEMBERSHIPS', id: 'ALL' }],
    }),
  }),
  overrideExisting: false,
});
